import { render, staticRenderFns } from "./NeedsAnalysis.vue?vue&type=template&id=8aff5d3c&"
import script from "./NeedsAnalysis.vue?vue&type=script&lang=js&"
export * from "./NeedsAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./NeedsAnalysis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports